import './styles.css';

import { cn } from '@/lib/utils';

export const Spinner = ({ className }: { className?: string }) => (
  <div className={cn('spinner h-4 w-4 animate-spin rounded-full', className)} />
);
